import React from 'react'
import { Modal, Button } from 'hljd'
import { inject, observer } from 'mobx-react'
import Chat from '@common/Chat'
import Style from './style.module.less'

export default inject('store')(
  observer(({ store: { liveLotteryStore } }) => {
    const {
      winningUsers,
      changeWinningUsersModalVisible,
      winningUsersModalVisible
    } = liveLotteryStore
    const length = winningUsers && winningUsers.length
    return (
      <Modal
        title={'中奖名单(' + length + ')'}
        visible={winningUsersModalVisible}
        onOk={changeWinningUsersModalVisible}
        wrapClassName={Style['winning-users-modal']}
        onCancel={changeWinningUsersModalVisible}
        footer={
          <Button type="primary" onClick={changeWinningUsersModalVisible}>
            好的
          </Button>
        }
      >
        <div className={Style['winning-users']}>
          {winningUsers.map((item, index) => (
            <div
              key={index}
              className={`${Style['users-item']} ${
                (index + 1) % 2 ? '' : Style['users-item-margin']
              }`}
            >
              <span className={Style['users-item-nick']}>{item.nick}</span>
              <Chat toUserId={item.userId} children={<span>私信</span>} />
            </div>
          ))}
        </div>
      </Modal>
    )
  })
)
